module.exports = __webpack_public_path__ + "static/media/glasphalt_gv.20f3005f.jpg";